import { State, process } from '@progress/kendo-data-query';
import { GridDataStateChangeEvent } from '@progress/kendo-react-grid';
import { isArray } from 'lodash';
import { FC, useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import GridWrapper from 'src/components/GridWrapper';
import { GLCodePeriodDepartment } from 'src/services/useGlCodeDepartmentApi';

interface Props {
  departments: GLCodePeriodDepartment[];
}

const defaultProps = {
  tableTextId: 'Transactions',
  DataItemKey: 'departmentId',
  sortable: true,
  resizable: true,
  showColumnMenu: true,
} as const;

const DepartmentsTable: FC<Props> = ({ departments }) => {
  const { t } = useTranslation();
  const [state, setState] = useState<State>({
    sort: [
      {
        field: 'departmentName',
        dir: 'asc',
      },
    ],
  });
  const onDataStateChange = useCallback((e: GridDataStateChangeEvent) => {
    setState(e.dataState);
  }, []);

  const { data } = process(departments, state);

  const isFilterApplied = useMemo(() => {
    if (state?.filter === undefined) {
      return false;
    } else if (isArray(state?.filter?.filters) && state?.filter?.filters !== undefined) {
      return true;
    }
  }, [state.filter]);

  return (
    <GridWrapper
      columns={[
        {
          field: 'departmentName',
          title: t('Department Name'),
          filter: 'text',
          dataType: 'string',
          menu: true,
          sortable: true,
        },
      ]}
      dataSource={data}
      dataState={state}
      noRecordText={
        isFilterApplied ? 'Remove filter to display Departments' : 'No records available'
      }
      onDataStateChange={onDataStateChange}
      style={{ maxHeight: '80vh' }}
      {...defaultProps}
      className="checkbook-department"
    />
  );
};

export default DepartmentsTable;
